import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

type Props = {
    onRetry: VoidFunction;
};

export const MeetingAgentMessageError = ({ onRetry }: Props) => {
    return (
        <Stack
            gap="8px"
            alignItems="flex-start"
            data-automation="meeting-agent-message-error"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("si.agent.meeting.error.message")}
            </Text>
            <IconButton
                type="flat"
                iconName="refresh"
                onClick={onRetry}
                dataAutomation="meeting-agent-retry-button"
            >
                {translate("si.common.retry")}
            </IconButton>
        </Stack>
    );
};
